import { NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DEFAULT_OPTIONS,
  MAT_DIALOG_SCROLL_STRATEGY,
  MatDialogConfig,
  MatDialogModule,
} from '@angular/material/dialog';

import { CustomDialogContentDirective } from './directives/custom-dialog-content.directive';

import { WlcmButtonModule } from '@wlcm/angular/button';
import { DialogBodyComponent } from './components/dialog-body/dialog-body.component';
import { DialogFooterComponent } from './components/dialog-footer/dialog-footer.component';
import { DialogHeaderComponent } from './components/dialog-header/dialog-header.component';
import { GenericDialogComponent } from './components/generic-dialog/generic-dialog.component';
import { CircleCloseIconComponent } from '@shared/components/icons/circle-close-icon/circle-close-icon.component';
import { DialogApi } from './services/dialog.api';
import { Overlay, NoopScrollStrategy } from '@angular/cdk/overlay';
import { IconComponent } from '@shared/components/icon/icon.component';

export function noopDialogScrolling(overlay: Overlay): () => NoopScrollStrategy {
  return () => overlay.scrollStrategies.noop();
}

const DIALOG_CONFIG: MatDialogConfig = {
  autoFocus: false,
  hasBackdrop: true,
  minWidth: '350px',
  maxHeight: '80vh',
};

const publicComponents: Type<unknown>[] = [
  GenericDialogComponent,
  DialogHeaderComponent,
  DialogFooterComponent,
  DialogBodyComponent,
];

@NgModule({
  declarations: [...publicComponents, CustomDialogContentDirective],
  imports: [CommonModule, MatDialogModule, WlcmButtonModule, CircleCloseIconComponent, IconComponent],
  exports: [...publicComponents, CustomDialogContentDirective],
  providers: [
    DialogApi,
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: DIALOG_CONFIG,
    },
    {
      provide: MAT_DIALOG_SCROLL_STRATEGY,
      useFactory: noopDialogScrolling,
      deps: [Overlay],
    },
  ],
})
export class DialogModule {}
